import { defineMessages } from 'react-intl';

export default defineMessages({

    termsTableView: {
        id: 'ri.gateway.billingDocuments.View',
        defaultMessage: 'View'
    },
    termsTableDiscription: {
        id: 'ri.gateway.billingDocuments.Description',
        defaultMessage: 'Description'
    },
    termsTableInvoicType: {
        id: 'ri.gateway.billingDocuments.Invoice Type',
        defaultMessage: 'Invoice Type'
    },
    termsTableInvoiceDate: {
        id: 'ri.gateway.billingDocuments.Invoice Date',
        defaultMessage: 'Invoice Date'
    },           
    noBillingDocsDataLabel: {
        id: 'ri.gateway.billingDocuments.No Billing invoices data for this policy, check back again in the next',
        defaultMessage: 'No billing invoices data for this policy, check back again in the next 24 hour'
    }
});
